import FreeLine from "./FreeLine";
import CallMadeIcon from '@mui/icons-material/CallMade';
import {FIXED_ANNO_HEIGHT} from "../drawer/draw_tool_keys";
import Polygon from "ol/geom/Polygon";
import Feature from "ol/Feature";

class Arrow extends FreeLine {

    id = "Arrow";
    name = "Arrow";
    icon = <CallMadeIcon/>;
    freehand = false;
    maxPoints = 10;

    onDrawStart = () => null;
    onDrawEnd = (event) => {
        const feature = event.feature;
        let geometry = feature.getGeometry();
        let coordinates = geometry.getCoordinates();
        const [x, y] = coordinates[1];
        const geometryCoordinates = [
            [x, y + FIXED_ANNO_HEIGHT / 4],
            [x, y - FIXED_ANNO_HEIGHT / 4],
            [x, y - FIXED_ANNO_HEIGHT / 4],
        ];
        const polyGeometry = new Polygon([geometryCoordinates]);
        const polyFeature = new Feature({
            geometry: polyGeometry
        })

        this.addFeatureAnnotation(feature);
        this.addLabelAnnotation(polyFeature)
    }

}

export default Arrow;